<template>
  <div class="waiting w-full">
    <div class="w-full text-center">
      <h1 class="my-6 text-xl md:text-2xl lg:text-3xl font-bold leading-tight text-gray-100"><span class='text-highlight'>ATTENTION!</span> Limited server...</h1>
      <cogSvg class="animate-spin-slow mx-auto w-10 h-10 md:w-12 md:h-12 lg:w-16 lg:h-16 fill-current text-gray-100" viewBox="0 0 512 512"/>
      <p class="my-6 text-sm md:text-base lg:text-lg font-medium leading-tight text-gray-100">You will be forwarded immediately, the server is just about to calculate a result for many people.</p>
    </div>
    <div class="relative pt-1">
      <div class="flex mb-2 items-center justify-between">
        <div>
          <span class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded bg-button text-gray-100">
            Your position: <span class='text-highlight'>{{ Math.floor(position) }}</span>
          </span>
        </div>
        <div class="text-right">
          <span class="text-xs font-semibold inline-block text-gray-100">
            {{ Math.floor(progress) }}%
          </span>
        </div>
      </div>
      <div class="overflow-hidden h-8 mb-4 p-1 flex rounded-md bg-progressBack progress-back-shadow">
        <div style="transition: width 0.4s;" :style="{'width' : progress + '%'}" class="flex flex-col rounded progress-front-shadow stripes bg-highlight"></div>
      </div>
    </div>
  </div>
</template>

<script>
import cogSvg from "@/assets/icons/cog.svg?inline";

export default {
  name: 'Waiting',
  data: function () {
    return {
      position: 0,
      progress: 0.0
    }
  },
  components: {
    cogSvg
  },
  created: function () {
    const _this = this; 

    let minPosition = 60;
    let maxPosition = 90;
    let randPosition = Math.floor(Math.random() * (maxPosition - minPosition + 1) ) + minPosition; 
    _this.position = randPosition;

    let invervalSpeed = 500.0;
    let waitingTime = 4500.0;
    let decrementCount = randPosition/(waitingTime/invervalSpeed);

    var progressInterval = setInterval(function(){
        _this.position -= decrementCount;

        _this.progress = ((randPosition-(_this.position-1.0))/randPosition)*100.0;
        if (_this.progress > 100.0) _this.progress = 100.0;

        if(_this.position < 1){
          _this.position = 1
          setTimeout(function(){_this.progressAction()}, 500);
          clearInterval(progressInterval);
        }
    }, invervalSpeed);
  },
  methods: {
    progressAction: function() {
      this.$emit('progress-message');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .progress-back-shadow {
      box-shadow: 0 1px 5px #000 inset, 0 1px 0 #444;
  }
  .progress-front-shadow {
      box-shadow: 0 1px 0 rgba(255, 255, 255, .5) inset;
  }
  .stripes {
    background-size: 30px 30px;
    background-image: linear-gradient(135deg, rgba(0, 0, 0, .08) 25%,
                      transparent 25%,
                      transparent 50%, rgba(0, 0, 0, .08) 50%, rgba(0, 0, 0, .08) 75%,
                      transparent 75%, transparent);
    animation: animate-stripes 2s linear infinite;
  }
  @keyframes animate-stripes {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: 60px 0;
    }
  }
</style>
